module.exports = {
  1: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  31: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  41: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  56: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  97: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  137: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  8453: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  17000: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  42161: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  43113: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  43114: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  59140: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  59144: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  80001: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  84532: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  421614: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  11155111: '0xd88cf00477B0Edd2C514e6474Ecfc44222830F58',
  245022926: '0x37e65CCF8a60E2420dEe21D9B0D98960Ea4d307D',
  245022934: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
}
